(function() {
    'use strict';

    angular
        .module('atheer.smartFlow')
        .controller('SmartFlowToolbarController', SmartFlowToolbarController);

    /* @ngInject */
    function SmartFlowToolbarController($rootScope, $scope, $state, $mdDialog, ParseLinks, AlertService, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, $translate, Feature, ToastService) {
        var vm = this;

        vm.refreshAll = refreshAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        vm.query = {
            filter: ''
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.createObject = createObject;

        vm.permissions = {
            create: 'create-workflow',
            update: 'update-workflow',
            delete: 'delete-workflow',
            manage: 'manage-workflow'
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
        };

        function refreshAll() {
            $scope.$emit('refreshSmartFlows', vm.query.filter);
        };

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            $scope.$emit('refreshSmartFlows', vm.query.filter);
        };

        function createObject() {
            $state.go("storm.admin-smartflow-detail", {
                'id': '',
                'isCopy': false,
                'isJobFlow': true
            });
        };
    }
})();
